<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout wrap no-gutters>
        <v-flex xs12 sm3 md4>
            <v-card class="pb-0">
              <v-toolbar dark color="primary">
              <v-toolbar-title>1. Seleccione Dia de Reserva</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form>
                       <v-date-picker
                        v-model="fecha"
                        class="mt-4"
                        @change="onFechaChange"
                        :min="getStartDate"
                        :max="getEndDate"
                        :allowed-dates="allowedDates"
                        locale='es-MX'
                      ></v-date-picker>
                      <v-chip
                        v-if="mensaje"
                        class="ma-2"
                        close
                        color="red"
                        outlined
                        @click:close="chip3 = false"
                      >
                         {{mensaje}} 
                      </v-chip>
              </v-form>
            </v-card-text>
            <FlashMessage></FlashMessage>
              
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 pl-4 mt-2>
            <v-card class="pb-0">
              <v-toolbar dark color="primary">
              <v-toolbar-title>2. Seleccione Nucleo Familiar</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form>
                    
              <div>
                    <div class="font-weight-normal">
                         <div v-for="(value, key) in participantes" :key="key">
                          <input type="checkbox" :id="key" v-model="partSeleccionado" :value="value.identificacion">
                          <label :for="key">{{ value.identificacion.slice(0,4).padStart(10,'*') }} {{ value.nombre }} - CAT: {{value.categoria}}</label>
                        </div>  
                   </div>
              </div>
               
              <div>
                 <div
                   v-for="(textField, i) in textFields"
                   :key="i"
                   class="text-fields-row"
                  >
                    <v-text-field
                     :label="textField.lblNumero"
                     v-model="textField.valorIdentificacion"
                    ></v-text-field>

                    <v-text-field
                     :label="textField.lblNombre"
                     v-model="textField.valorNombre"
                    ></v-text-field>
                    <v-btn small @click="remove(i)" class="error">Quitar Particular</v-btn>
                  </div>
                  <v-btn small @click="add" class="primary">Agregar Particular</v-btn>
              </div>   
              </v-form>
            </v-card-text>
              
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 pl-4 mt-2>
           <v-card class="pb-0">
              <v-toolbar dark color="primary">
              <v-toolbar-title>3. Seleccione el Servicio </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0 mx-auto"  max-width="400" tile>
                <div v-for="(value, key) in bolsa" :key="key" class="pb-2">
                          <input type="radio" :id="key" name="servi" v-model="servicios" :value="key">
                          <label :for="key">{{ value[0].nombre }} 
                            {{ value[0].cat }}: {{value[0].valor }}
                            {{ typeof value[1] !== "undefined" ? value[1].cat:'' }}: {{ typeof value[1] !== "undefined" ? value[1].valor:''}}</label>
                </div>

                <div class="pt-2 pb-2">
                 <h3 style="text-align:center"> VALOR ESTIMADO: {{total}} </h3>
                </div>
                 
            </v-card-text>
            </v-card>
            <v-card-actions class="px-5">
               <v-layout row>
              <v-flex xs12 md6>
                  <v-btn outline block @click="save" :disabled="!valid" color="primary">
                    Apartar Cita
                  </v-btn>
                </v-flex>
               <v-flex xs12 md6>   
                  <v-btn outline block @click="devolver"  color="primary" >
                    Devolver
                  </v-btn>
                  
              </v-flex>
            </v-layout>
            </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
     <v-dialog persistent v-model="dialogSuccess" max-width="560px">
      <v-card>
        <v-card-title class="headline blue darken-1 white--text"  primary-title>
          Reservacion Teyuna
        </v-card-title>
        <v-card-text>
          <p>Su cupo ha sido apartada </p>
          <p><strong>Sr(a). Usuario, gracias por utilizar los sevicios de la Caja de Compensacion Familiar del Magdalena, la reserva de sus {{ this.partSeleccionado.length + this.textFields.length}} cupos para el servicio {{this.textServicio}}, a sido registrada con exito.
Nota: Recuerde que el valor total del servicio solo debe ser cancelado en la taquilla del Centro Recreacional, del mismo modo, si pasadas las 2:00 pm del dia de la reservacion, usted no ha asistido la reservacion quedara anulada.</strong></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="closeSuccess"><v-icon class="blue--text text--lighten-2">chevron_right</v-icon>Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogLoading"
        hide-overlay
        persistent
        width="300"
    >
      <v-card color="primary" dark
      >
        <v-card-text>
          Por favor, espere...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
  

</template>

<script>
  import {turnoService} from "../services/turnoService"
  import {router} from "../router";

  export default {
    data: () => ({
      textFields: [],
      partSeleccionado:[],
      participantes: [],
      checkbox: true,
      valid: true,
      mensaje: false,
      fecha: '',
      loading: false,
      dialog: false,
      dialogLoading: false,
      dialogSuccess: false,
      servicios: [], 
      bolsa: [],
      minimo: new Date().toISOString().slice(0,10),
      cupos:0,
      textServicio:'',
    }),
    computed: {
        total: function(){
          var valor = 0;
          var valSer = 0;
          var part = 0;
          var cant = 0;
          var valSerPar = 0;
          if(this.servicios.length==0){
            return 0;
          }
          console.log(this.servicios);
          console.log(this.bolsa);
          console.log(this.bolsa[this.servicios]);
          valSer = this.bolsa[this.servicios][0].valor;
          this.textServicio = this.bolsa[this.servicios][0].nombre;
          
          if(this.bolsa[this.servicios].length > 1){
            valSerPar = this.bolsa[this.servicios][1].valor;  
            part = this.textFields.length;
            cant = this.partSeleccionado.length;
            valor = cant*valSer + part*valSerPar;
          }else{
            valSerPar = this.bolsa[this.servicios][0].valor;  
            part = this.textFields.length;
            cant = this.partSeleccionado.length;
            valor = cant*valSer + part*valSerPar;
          }
          
          

          const options1 = { style: 'currency', currency: 'USD' };
          const numberFormat1 = new Intl.NumberFormat('en-US', options1);
          return numberFormat1.format(valor);
        },
        getEndDate() {
          var dt = new Date(this.getStartDate);
          dt.setMonth( dt.getMonth() + 2 )
          var fec = new Date( dt.getFullYear(), dt.getMonth(),dt.getDay())
          var offset = fec.getTimezoneOffset()
          var yourDate = new Date(fec.getTime() - (offset*60*1000))
          return yourDate.toISOString().split('T')[0]

        },
        getStartDate(){
          var fecha = new Date()
          var offset = fecha.getTimezoneOffset()
          var yourDate = new Date(fecha.getTime() - (offset*60*1000))
          return yourDate.toISOString().split('T')[0]

        }
    },
    created() {
      
      this.participantes = JSON.parse(localStorage.getItem('inte')).nucleo;
      this.bolsa = JSON.parse(localStorage.getItem('inte')).bolsa;
    },
    watch: {
      dialog(val) {
        val || this.close()
      },
      dialogLoading(val) {
        val || this.close()
      },
    },
    methods: {
      //:allowed-dates="allowedDates"
       allowedDates: val => {
          var year = parseInt(val.split('-')[0]);
          var month = parseInt(val.split('-')[1]);
          var day = parseInt(val.split('-')[2]);
          
          if(year==2022 && month == 3 && day == 13){
            return false;
          }

          if(([0,2,3,4,5,6,7].indexOf(new Date(year,month-1, day).getDay()) != -1)

           ){
             return true;
          }
       }
       ,
       add () {
        this.textFields.push({ 
          lblNumero: "Numero Identificacion", 
          valorIdentificacion: "",
          lblNombre: "Nombre",
          valorNombre: ""
        })
     },

     remove (index) {
         this.textFields.splice(index, 1)
     },

      onFechaChange(fecha) {
        let datosPaciente = JSON.parse(localStorage.getItem('inte'));
        
        var documento = null;
        
        if(Array.isArray(datosPaciente)){
          documento = datosPaciente[0].documento;
        }else{
          documento = datosPaciente.documento;
        }

         turnoService.verificaTeyuna(documento, fecha).then( data => {
             if(data.status==500){
               this.fecha = '';
               this.mensaje = data.msj

             }else{
                if(data.cupos == 0){
                  this.mensaje = "No tenemos cupos para este día.";
                  console.log(this.mensaje);
                }else{
                  this.mensaje = '';
                  this.cupos = data.cupos  
                }
                
             }
          },
          error => {
            console.log("error consultando...");
          }
        );



      },
      close() {
        this.dialog = false
      },
      closeSuccess() {
        this.dialogSuccess = false
        router.push('/')
      },
      devolver() {
          localStorage.clear();
          router.push('/');
      },
      save() {
        //let diaPicoCedula = JSON.parse(localStorage.getItem('horario'));
        let datosPaciente = JSON.parse(localStorage.getItem('inte'));
        var pacienteId=null; var documento =null; var celular =null; var email =null; var codins =null; var categoria = null;
        if(Array.isArray(datosPaciente)){
          documento = datosPaciente[0].documento;
          celular = datosPaciente[0].celular;
          email = datosPaciente[0].email;  
          categoria = datosPaciente[0].categoria;
        }else{
          documento = datosPaciente.documento;
          celular = datosPaciente.celular;
          email = datosPaciente.email;
          categoria = datosPaciente.categoria;
        }

        
       /* if(!this.validarPicoyCedula(documento, this.fecha)){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Este dia no permite apartarlo por no tener pico y cedula'+t})
          return false;
        }*/

        
        if(!this.fecha){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Debe seleccionar un dia!!'})
          return false;
        }
        
        if(this.servicios.length==0){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Debe seleccionar un tipo de servicio!!'})
          return false;
        }
                
        if(this.partSeleccionado.length==0 && categoria!='D'){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Debe seleccionar el(los) participantes!!'})
          return false;
        } 

        if((this.partSeleccionado.length + this.textFields.length)> this.cupos ){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Para el dia: '+this.fecha+ ' solo tenemos '+ this.cupos+ ' cupos disponible(s)'})
          return false;
        }

        this.dialogLoading = true;

        
        turnoService.reservarTurnoTeyuna(documento, celular, email, this.partSeleccionado, this.fecha, this.textFields, this.servicios, categoria, this.textServicio).then(
          data => {
            console.log(data);
           if(data.status==200){
            console.log("exito");
              this.dialogLoading = false;
              this.dialogSuccess = true;
              

               setTimeout(function(){
                  localStorage.setItem('inte',null);
                  router.push('/');    
                }, 8000); 

            }else{
              console.log("fallo");
              this.dialogLoading = false;
              this.flashMessage.show({status: 'error', title: 'Error', message: data.msj})
            }
          },
          error => {
            console.log("error saving...");
          }
        );
        console.log("close...");
        this.close()
      },
    },
  }
</script>
<style>
  .v-alert {
    margin: 90px 0 90px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Reservacion.vue